export const getContactsData = state => state.contacts

export const isLoadingContacts = state => getContactsData(state).isLoading

export const getContactsList = state => getContactsData(state).contactsList

export const getAddressesList = state =>
  getContactsList(state).filter(({ type }) => type == 'morada')

export const getPhonesList = state =>
  getContactsList(state).filter(({ type }) => type == 'telefone')

export const getEmailsList = state =>
  getContactsList(state).filter(({ type }) => type == 'email')

export const getSocialsList = state =>
  getContactsList(state).filter(({ type }) => type == 'social')
